import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { Box, TextField, Autocomplete, Container } from "@mui/material";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import FormControl from "@mui/material/FormControl";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import dayjs from "dayjs";
import axios from "axios";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { useRef } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { signOut } from "firebase/auth";

import DownloadButton from "../chatpage/downloadButton";
import { UseSnackbar } from "../snackbar/snackbarContext";
import Greenbanner from "../header/greenbanner";
import { auth } from "../../auth/firebase-config";
import { mapBackendSectionToDisplayName } from "@/utils/util";
import "./dashboard.css";

function Dashboard_table({ selectedId, handleSelectDocument }) {
  const doctypes = [
    "Feature Needs with Rationale",
    "Use cases",
    "Feature Requirements with Rationale",
    "User Stories",
    "Test Case Steps",
    "Acceptance Criteria & Expected Results",
    "System Requirements",
    "End to End Traceability",
  ];

  const [projects, setProjects] = useState([]);

  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalDocs, setTotalDocs] = useState(1);

  const [rows, setrows] = useState([]);

  const [open, setOpen] = useState(false);
  const [projectflag, setprojectflag] = useState(false);
  const [traceabilty, settraceabilty] = useState(false);
  const [value, setValue] = useState("");
  const [product, setproduct] = useState("");

  const [searchValue, setSearchValue] = useState("");
  const [filterdata, setfilterdata] = useState([]);
  const [covloader, setCovloader] = useState(false);
  const [uniqueProducttype, setuniqueProducttype] = useState([]);
  const [uniqueDocumenttype, setuniqueDocumenttype] = useState([]);

  const [selectedDate, setSelectedDate] = useState(null);

  const [cleared, setCleared] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const open1 = Boolean(anchorEl);

  const [document_type, setdocumenttype] = useState("");
  const [product_type, setproducttype] = useState("");
  const showSnackbar = UseSnackbar();

  const storedUserInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const today = new Date();
  const columns = [
    { id: "productType", label: "Project Name", minWidth: 100 },
    { id: "name", align: "left", label: "Document Name", minWidth: 170 },
    { id: "version", align: "center", label: "Version", minWidth: 170 },
    {
      id: "documentType",
      label: "Document Type",
      minWidth: 170,
      align: "left",
    },
    {
      id: "dateModified",
      label: "Created Date",
      minWidth: 170,
      align: "center",
      format: (value) => new Date(value).toLocaleDateString("en-US"),
    },
    {
      id: "createdby",
      label: "Created By",
      minWidth: 170,
      align: "left",
    },
    {
      id: "action",
      label: "Action",
      minWidth: 170,
      align: "center",
    },
  ];

  const handleselect = (
    document_id,
    conversation_id,
    productType,
    documentType,
    gcs_url,
    doc_name
  ) => {
    const selected_value = {
      document_id: document_id,
      conversation_id: conversation_id,
      project_type: productType,
      doctype: documentType,
      gcs_url: gcs_url,
      doc_name: doc_name,
    };
    handleSelectDocument(selected_value);
  };

  const createActionButtons = (
    user_id,
    document_id,
    conversation_id,
    productType,
    documentType,
    gcs_url,
    doc_name
  ) => {
    const data = JSON.parse(localStorage.getItem("user_data"));
    const userid = data.id;

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Stack direction="row" spacing={1}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row-reverse",
              padding: "1rem",
              gap: "1rem",
            }}
          >
            <Button
              variant="contained"
              sx={{ textTransform: "capitalize", fontSize: "1rem" }}
              onClick={() =>
                handleselect(
                  document_id,
                  conversation_id,
                  productType,
                  documentType,
                  gcs_url,
                  doc_name
                )
              }
            >
              Select
            </Button>
          </Box>
        </Stack>
      </div>
    );
  };

  const createData = (
    user_id,
    document_id,
    version,
    conversations_id,
    name,
    productType,
    documentType,
    dateModified,
    gcs_url,
    createdby
  ) => {
    return {
      user_id,
      document_id,
      version: "v " + parseFloat(version).toFixed(1),
      conversations_id,
      name,
      productType,
      documentType,
      gcs_url,
      dateModified: (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "1rem",
          }}
        >
          <AccessTimeIcon style={{ marginRight: "0.5rem" }} />
          {new Date(dateModified)
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })
            .replace(/ /g, "-")}
        </div>
      ),
      createdby,
      action: createActionButtons(
        user_id,
        document_id,
        conversations_id,
        productType,
        documentType,
        gcs_url,
        name
      ),
    };
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleproduct = () => {
    setproduct(value);
    handleClose();
    const url = `/upload?project_name=${encodeURIComponent(value)}`;
    navigate(url, { state: { traceabilty } });
  };

  const handlecreateproduct = async () => {
    const res = await createproject(value);
    fetchallproject();
    setproduct(res.data.project_name);
    handleClose();
    navigate(
      `/upload?project_name=${encodeURIComponent(res.data.project_name)}`
    );
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorEl(null);
  };

  const handleproductChange = (event) => {
    setproducttype(event.target.value);
  };

  const handledocumentChange = (event) => {
    setdocumenttype(event.target.value);
  };

  const handleclearfilters = () => {
    setdocumenttype("");
    setproducttype("");
    handleClose1();
  };

  const handleapplyfilters = () => {
    filterData(searchValue, startDate, endDate);
    handleClose1();
  };

  const handleSearchChange = (event) => {
    const searchValue = event.target.value;
    setSearchValue(searchValue);
  };
  const handleSearchEnterPress = (event) => {
    if (event.key === "Enter") {
      filterData(searchValue, startDate, endDate);
    }
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);

    filterData(searchValue, startDate, endDate);
  };

  const filterData = (search, startDate, endDate) => {
    storeUserdata();
    setPage(0);
  };

  const setcleardate = () => {
    setCleared(true);
    handleDateChange(null);
  };

  useEffect(() => {
    if (uniqueProducttype.length === 0 && uniqueDocumenttype.length === 0) {
      setuniqueDocumenttype(
        [...new Set(rows.map((row) => row.documentType))].sort()
      );
      setuniqueProducttype(
        [...new Set(rows.map((row) => row.productType))].sort()
      );
    }
  }, [uniqueProducttype, uniqueDocumenttype]);

  useEffect(() => {
    if (covloader) {
    }
    if (selectedId) {
      setdocumenttype(selectedId);
      storeUserdata();
    }
    if (filterdata.length === 0) {
      fetchallproject();
    }
  }, [
    rowsPerPage,
    page,
    startDate,
    endDate,
    document_type,
    product_type,
    selectedId,
  ]);

  const storeUserdata = async () => {
    let filetrString = "";
    if (startDate) {
      filetrString = filetrString + "start_date=" + startDate + "&";
    }
    if (endDate) {
      filetrString = filetrString + "end_date=" + endDate + "&";
    }
    if (product_type) {
      filetrString = filetrString + "project_name=" + product_type + "&";
    }
    if (searchValue) {
      filetrString = filetrString + "document_name=" + searchValue + "&";
    }
    if (document_type) {
      if (document_type === "Feature Needs with Rationale") {
        filetrString += `document_type=${encodeURIComponent("Feature Needs with Rationale, Feature needs with Rationale")}&`;
      } else {
        filetrString =
          filetrString +
          "document_type=" +
          encodeURIComponent(document_type) +
          "&";
      }
    }

    if (filetrString) {
      filterdatacall(filetrString);
    }
  };
  const filterdatacall = async (filetrString) => {
    const accessToken = localStorage.getItem("accessToken");
    const API_URL = `${
      import.meta.env.VITE_API_URL
    }/documents?${filetrString}page=${page}&limit=${rowsPerPage}`;

    setCovloader(true);
    try {
      const userResponse = await userdata();
      const users = userResponse.data;
      const response = await axios.get(API_URL, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });

      const ddata = response.data.data.Documents;
      const totalDocs = response.data.data.total_docs;

      const sample = ddata
        .filter((doc) => doc.save_dashboard)
        .map((doc) => {
          const user = users.find((u) => u.id === doc.user_id);
          const createdby = user ? user.name : "Unknown User";

          return createData(
            doc.user_id,
            doc.id,
            doc.document_version,
            doc.conversations_id,
            doc.document_name,
            doc.project_name,
            doc.type,
            doc.created_time,
            doc.doc_url,
            createdby
          );
        });

      setrows(sample);
      setfilterdata(sample);
      setTotalDocs(totalDocs);
      setCovloader(false);

      return response;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        signOut(auth)
          .then(() => {
            localStorage.removeItem("userInfo");
            localStorage.removeItem("accessToken");
            localStorage.removeItem("user_data");
            console.log("User signed out due to inactivity.");
          })
          .catch((signOutError) => {
            console.error("Error signing out:", signOutError);
          });
      } else {
        if (error.response && error.response.status === 401) {
          signOut(auth)
            .then(() => {
              localStorage.removeItem("userInfo");
              localStorage.removeItem("accessToken");
              localStorage.removeItem("user_data");
              console.log("User signed out due to inactivity.");
            })
            .catch((signOutError) => {
              console.error("Error signing out:", signOutError);
            });
        } else {
          showSnackbar("Something Went Wrong! Please Try again! ", "error");
          throw new Error(`Internal server error: ${error}`);
        }
      }
    }
  };
  const userdata = async () => {
    const accessToken = localStorage.getItem("accessToken");
    const API_URL = `${import.meta.env.VITE_API_URL}/users?skip=0&limit=0`;
    try {
      const response = await axios.get(API_URL, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        signOut(auth)
          .then(() => {
            localStorage.removeItem("userInfo");
            localStorage.removeItem("accessToken");
            localStorage.removeItem("user_data");
            console.log("User signed out due to inactivity.");
          })
          .catch((signOutError) => {
            console.error("Error signing out:", signOutError);
          });
      } else {
        showSnackbar("Something Went Wrong! Please Try again! ", "error");
        throw new Error(`Internal server error: ${error}`);
      }
    }
  };

  const fetchallproject = async () => {
    const accessToken = localStorage.getItem("accessToken");
    const API_URL = `${import.meta.env.VITE_API_URL}/project`;
    try {
      const response = await axios.get(API_URL, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });
      const res = response.data.data;
      setProjects((prevProjects) => {
        const newProjects = [...prevProjects];
        res.forEach((val) => {
          if (!newProjects.includes(val.project_name)) {
            newProjects.push(val.project_name);
          }
        });
        return newProjects;
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        signOut(auth)
          .then(() => {
            localStorage.removeItem("userInfo");
            localStorage.removeItem("accessToken");
            localStorage.removeItem("user_data");
            console.log("User signed out due to inactivity.");
          })
          .catch((signOutError) => {
            console.error("Error signing out:", signOutError);
          });
      } else {
        showSnackbar("Something Went Wrong! Please Try again! ", "error");
        throw new Error(`Internal server error: ${error}`);
      }
    }
  };

  const createproject = async (project_name) => {
    const accessToken = localStorage.getItem("accessToken");
    const API_URL = `${import.meta.env.VITE_API_URL}/project`;
    try {
      const response = await axios.post(
        API_URL,
        { project_name },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      showSnackbar(response.data.message, "success");
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        signOut(auth)
          .then(() => {
            localStorage.removeItem("userInfo");
            localStorage.removeItem("accessToken");
            localStorage.removeItem("user_data");
            console.log("User signed out due to inactivity.");
          })
          .catch((signOutError) => {
            console.error("Error signing out:", signOutError);
          });
      } else {
        showSnackbar("Something Went Wrong! Please Try again! ", "error");
        throw new Error(`Internal server error: ${error}`);
      }
    }
  };

  const handleStartDateChange = (newStartDate) => {
    setStartDate(newStartDate);

    if (endDate && newStartDate && dayjs(newStartDate).isAfter(endDate)) {
      setEndDate(null);
    }
    setPage(0);
  };

  const handleEndDateChange = (newEndDate) => {
    setEndDate(newEndDate);

    setPage(0);
  };

  const setClearDates = () => {
    setStartDate(null);
    setEndDate(null);
    filterData(searchValue, null, null);
  };

  const handleTraceablity = () => {
    settraceabilty(true);
    setOpen(true);
  };
  return (
    <div>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            marginTop: "3rem",
          }}
        >
          <Typography
            variant="h4"
            component="div"
            sx={{ textTransform: "capitalize", fontWeight: "bold" }}
          >
            Dashboard Documents Files
          </Typography>
        </div>
        <div style={{ width: "100%" }}>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              marginBottom: "1rem",
              gap: "1rem",
            }}
          >
            <Box
              sx={{
                width: "80%",
                maxWidth: "100%",
                paddingTop: "1rem",
              }}
            >
              <TextField
                fullWidth
                label="Search for existing documents..."
                id="search"
                value={searchValue}
                onChange={handleSearchChange}
                onKeyDown={handleSearchEnterPress}
              />
            </Box>

            <Box sx={{ maxWidth: "100%" }}>
              <Box
                sx={{
                  display: "flex",
                  gap: "1rem",
                  alignItems: "baseline",
                  paddingTop: "0.5rem",
                }}
              >
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  sx={{ paddingTop: "1rem" }}
                >
                  <DemoContainer components={["DatePicker"]}>
                    <DatePicker
                      format="MM-DD-YYYY"
                      label="Start Date"
                      value={startDate}
                      onChange={handleStartDateChange}
                      maxDate={dayjs(today)}
                      slotProps={{
                        field: {
                          clearable: true,
                          onClear: setClearDates,
                          inputProps: {
                            readOnly: true,
                          },
                        },
                        popper: {
                          sx: {
                            ".MuiPickersDay-root, .MuiPickersCalendarHeader-root, .MuiDayPicker-weekDayLabel, .MuiTypography-caption":
                              {
                                fontSize: "15px",
                              },
                          },
                        },
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  sx={{ paddingTop: "1rem" }}
                >
                  <DemoContainer components={["DatePicker"]}>
                    <DatePicker
                      format="MM-DD-YYYY"
                      label="End Date"
                      value={endDate}
                      onChange={handleEndDateChange}
                      minDate={startDate}
                      maxDate={dayjs(today)}
                      slotProps={{
                        field: {
                          clearable: true,
                          onClear: setClearDates,
                          inputProps: {
                            readOnly: true,
                          },
                        },
                        popper: {
                          sx: {
                            ".MuiPickersDay-root, .MuiPickersCalendarHeader-root, .MuiDayPicker-weekDayLabel, .MuiTypography-caption":
                              {
                                fontSize: "15px",
                              },
                          },
                        },
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </Box>
            </Box>

            <Box sx={{ paddingTop: "1rem" }}>
              <Button
                onClick={handleClick}
                sx={{ padding: "0.9rem" }}
                variant="outlined"
                startIcon={<TuneOutlinedIcon />}
              >
                <Typography
                  variant="h5"
                  component="div"
                  sx={{ textTransform: "capitalize" }}
                >
                  Filters
                </Typography>
              </Button>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                <Box sx={{ minWidth: 400 }}>
                  <Box sx={{ padding: "1rem" }}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Select a Project Name...
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={product_type}
                        label="Select a Project Name..."
                        onChange={handleproductChange}
                      >
                        {projects.map((key) => (
                          <MenuItem key={key} value={key}>
                            {key}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                  <Box sx={{ padding: "1rem" }}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Select a Document type...
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={document_type}
                        disabled
                        label="Select a Document type..."
                        onChange={handledocumentChange}
                      >
                        {doctypes.map((key) => (
                          <MenuItem key={key} value={key}>
                            {key}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row-reverse",
                      padding: "1rem",
                      gap: "1rem",
                    }}
                  >
                    {/* <Button
                      onClick={handleapplyfilters}
                      variant="contained"
                      sx={{ textTransform: "capitalize" }}
                    >
                      Apply Filters
                    </Button> */}
                    <Button
                      onClick={handleclearfilters}
                      variant="contained"
                      sx={{ textTransform: "capitalize" }}
                    >
                      Clear Filters
                    </Button>
                  </Box>
                </Box>
              </Menu>
            </Box>
          </div>
          <div style={{ paddingBottom: "2rem" }}>
            <Paper sx={{ width: "100%", overflow: "hidden" }}>
              <TableContainer className="table-container">
                {!covloader ? (
                  <Table
                    stickyHeader
                    aria-label="a dense sticky table"
                    size="small"
                  >
                    <TableHead>
                      <TableRow>
                        {columns.map((column, i) => (
                          <TableCell
                            key={column.id}
                            align={column.align}
                            style={{
                              minWidth: column.minWidth,
                              backgroundColor: "bisque",
                              fontSize: "1rem",
                              fontWeight: "bold",
                              padding: "10px",
                            }}
                          >
                            {column.label}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filterdata.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={columns.length} align="center">
                            <Typography variant="h4">
                              No data available...
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ) : (
                        filterdata.map((row, i) => {
                          return (
                            <TableRow
                              hover
                              role="checkbox"
                              tabIndex={-1}
                              key={row.code}
                            >
                              {columns.map((column) => {
                                let value = row[column.id];
                                if (column.label === "Document Type")
                                  value = mapBackendSectionToDisplayName(
                                    row[column.id]
                                  )
                                    ? mapBackendSectionToDisplayName(
                                        row[column.id]
                                      )
                                    : row[column.id];
                                return (
                                  <TableCell
                                    key={column.id}
                                    align={column.align}
                                    sx={{ fontSize: "1rem", padding: "10px" }}
                                  >
                                    {column.format && typeof value === "number"
                                      ? column.format(value)
                                      : value}
                                  </TableCell>
                                );
                              })}
                            </TableRow>
                          );
                        })
                      )}
                    </TableBody>
                  </Table>
                ) : (
                  <Box
                    sx={{
                      width: "100%",
                      alignItems: "center",
                      justifyContent: "center",
                      display: "flex",
                      flexDirection: "column",
                      backdropFilter: "blur(5px)",
                      paddingTop: "2rem",
                      paddingBottom: "2rem",
                    }}
                  >
                    <CircularProgress />
                    <Typography variant="h4" sx={{ mt: 1 }}>
                      Loading Data...
                    </Typography>
                  </Box>
                )}
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[10, 25, 50, 100]}
                component="div"
                count={totalDocs}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard_table;
